import { BASE_URL } from "./variables";

export const addPatient = async (patientData) => {
  try {
    
    // Use business auth token if available, otherwise use default token
    const businessToken = localStorage.getItem('businessAuthToken');
    const authToken = businessToken || 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ1c2VySWQiOjEsImJ1c2luZXNzSWQiOjEsIk1lbWJlcklEIjoxLCJ1c2VybmFtZSI6ImFkbWluIiwiZmlyc3ROYW1lIjoiQWRtaW5pc3RyYXRvciIsImxhc3ROYW1lIjoiQW5rb3RhIiwiYXBpQWNjZXNzIjpmYWxzZSwiZXhwIjoyNTM0MDIyMTQ0MDB9.AxVVChn_pG_7u8Btwjn_4TMiIu22Tvf9cSIqQKGHeOU';
    
    const response = await fetch(`${BASE_URL.replace('/fms', '')}/patients/add-patient`, {
      method: 'POST',
      headers: {  
        'Content-Type': 'application/json',
        'Accept': 'application/json',
        'Authorization': `Bearer ${authToken}`
      },
      body: JSON.stringify(patientData)
    });

    if (!response.ok) {
      const errText = await response.text().catch(() => '');
      console.error(`addPatient: HTTP ${response.status} ${response.statusText}`, errText);
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    console.log('addPatient: response=', data);
    return data;
  } catch (error) {
    console.error("Error adding patient:", error);
    throw error;
  }
};

export default addPatient;